<template>
    <h-table
        :data="documents"
        v-if="documents.length"
        row-key="label"
        :columns="columns"
        :pagination.sync="pagination"
        :rows-per-page-options="perPageOptions"
        :loading="documentsLoading"
    >
        <q-td
            slot="body-cell-name"
            slot-scope="props"
        >
            <a
                :href="`/${ props.row.link }`"
                target="_blank"
            >
                {{ props.value }}
            </a>
        </q-td>
        <q-td
            slot="body-cell-edit"
            slot-scope="props"
            class="text-right"
        >
            <div class="flex no-wrap justify-end">
                <q-btn
                    @click="sendDocument(props.row)"
                    :loading="props.row.sending"
                    icon="send"
                    color="tertiary"
                    class="hover-primary"
                    flat
                    round
                >
                    <q-tooltip
                        :delay="500"
                        :offset="[0, 5]"
                    >
                        Выгрузить во Вчасно
                    </q-tooltip>
                </q-btn>
                <q-btn
                    @click="deleteDocument(props.row)"
                    :loading="props.row.deleting"
                    :disable="props.row.canDelete"
                    icon="delete"
                    color="tertiary"
                    class="hover-negative"
                    flat
                    round
                >
                    <q-tooltip
                        v-if="props.row.canDelete"
                        :delay="500"
                        :offset="[0, 5]"
                    >
                        Удалить
                    </q-tooltip>
                </q-btn>
            </div>
        </q-td>
    </h-table>
</template>

<script>
import HTable from '@/HTable';
import HTh from '@/HTh';

import columns from './mixins/columns';
import api from 'mixins/api';

import {
  QField,
  QInput,
  QSelect,
  QBtn,
  QIcon,
  QTable,
  QTableColumns,
  QTooltip,
  QTr,
  QTh,
  QTd,
  QPopover,
  QModal,
  QDatetime,
  QToggle,
} from 'quasar';

import { mapState } from "vuex";

export default {
  name: 'DocumentsList',
  components: {
    HTable,
    HTh,
    QField,
    QInput,
    QSelect,
    QBtn,
    QIcon,
    QTable,
    QTableColumns,
    QTooltip,
    QTr,
    QTh,
    QTd,
    QPopover,
    QModal,
    QDatetime,
    QToggle,
  },
  mixins: [
    columns,
    api
  ],
  data() {
    return {
      documents: [],
      perPageOptions: [10, 20, 40, 60],
      pagination: {
        page: 1,
        rowsPerPage: 20,
      }
    };
  },
  computed: {
    ...mapState('project', {
      documentsData: 'documents',
      documentsLoading: 'documentsLoading'
    }),
  },
  watch: {
    documentsData(value) {
      this.documents = value.map((contract) => {
        return {
          id: contract.id,
          canDelete: Boolean(contract.vchasno_id),
          createdAt: contract.created_at,
          name: this.extractFileName(contract.source_store),
          link: contract.source_store,
          sending: false,
          deleting: false
        }
      });
    },
  },
  mounted() {
    this.fetchDocuments();
  },
  methods: {
    fetchDocuments() {
      this.$store.dispatch('project/fetchDocuments', this.$route.params.id);
    },
    deleteDocument(document) {
      if (!confirm('Удалить этот документ?')) {
        return;
      }
      document.deleting = true;
      this.$store.dispatch('project/deleteDocument', {
        projectId: this.$route.params.id,
        documentId: document.id
      }).then((response) => {
        if (response) {
          this.$q.notify({
            message: 'Документ успешно удален',
            type: 'positive'
          });
        } else {
          this.$q.notify({
            message: 'Не удалось удалить документ',
            type: 'negative'
          });
        }
        document.deleting = false;
      });
    },
    sendDocument(document) {
      document.sending = true;
      this.$store.dispatch('project/sendDocument', {
        document
      }).then((response) => {
        if (response) {
          this.$q.notify({
            message: 'Документ успешно отправлен',
            type: 'positive'
          });
        } else {
          this.$q.notify({
            message: 'Не удалось отправить документ',
            type: 'negative'
          });
        }
        document.sending = false;
      });
    },
    extractFileName(path) {
      const chunks = path.split('/');

      return chunks[chunks.length - 1];
    },
  }
};
</script>

<style lang="scss" scoped>

</style>


// WEBPACK FOOTER //
// resources/assets/js/components/DocumentsList/DocumentsList.vue